import FormSection from "../../Forms/FormSection/form-section";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import {
  Autocomplete,
  Chip,
  FormControl,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useEffect, useState } from "react";
import { userService } from "../../../Core/Api/services";
import { MailingListDto } from "../../../Core/Api/Types/get-mailing-list-response";
import { useTranslation } from "react-i18next";

export type ShareUserAccessBoxProps = {
  share: any;
  onChange?: (emails?: string[]) => void;
};

const ShareUserAccessBox: React.FC<ShareUserAccessBoxProps> = (props) => {
  const { t } = useTranslation();
  const [emailList, setEmailList] = useState<MailingListDto[]>([]);
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
  const [email, setEmail] = useState<any>();
  const { share, onChange } = props;

  useEffect(() => {
    setSelectedEmails(share.recipientEmails);
    userService.GetMailingList().then(function (response) {
      if (response !== null) {
        setEmailList(response);
      }
    });
  }, []);

  useEffect(() => {
    onChange && onChange(selectedEmails);
  }, [selectedEmails]);

  const onDeleteEmail = (value) => {
    setSelectedEmails((current) =>
      current.filter((element) => {
        return element !== value;
      })
    );
  };

  const addEmailManually = (value) => {
    value.map((email) => {
      if (!selectedEmails?.includes(email)) {
        setSelectedEmails([...selectedEmails, ...[email]]);
      }
    });
  };

  const addEmails = (value) => {
    value.map((email) => {
      if (!selectedEmails?.includes(email)) {
        setSelectedEmails([...selectedEmails, ...[email]]);
      }
    });
  };

  return (
    <FormSection
      icon={<PersonOutlineOutlinedIcon />}
      defaultExpanded={true}
      title={t("common:recipients")}
      status={selectedEmails.length > 0 ? "complete" : "todo"}
      statusText={selectedEmails.length > 0 ? selectedEmails.join(" · ") : t("common:configurationRequired")}
    >
      <FormControl sx={{ mb: 1 }}>
        <InputLabel shrink htmlFor="localized-title">
          {t("field:label.addEmailManuallyLowerCase")}
        </InputLabel>
        <Autocomplete
          value={[]}
          multiple
          onChange={(e, value) => {
            addEmailManually(value);
            setEmail([]);
          }}
          options={[]}
          freeSolo
          renderInput={(params) => <TextField {...params} placeholder={t("field:placeholder.email")} />}
        />
      </FormControl>

      <FormControl sx={{ mb: 2 }}>
        <InputLabel htmlFor="emailList" sx={{ mb: 1 }}>
          {t("field:label.loadPreConfiguredMailingList")}
        </InputLabel>
        <Autocomplete
          id="emailList"
          options={emailList}
          onChange={(e, value) => {
            if (value !== null) addEmails(value.emails);
          }}
          popupIcon={<ExpandMoreRoundedIcon />}
          getOptionLabel={(value: any) => value.name}
          renderInput={(params) => (
            <OutlinedInput
              {...params.InputProps}
              inputProps={params.inputProps}
              placeholder={t("field:placeholder.mailingList")}
              sx={{ width: "100%" }}
            />
          )}
        />
      </FormControl>

      <Typography color="text.primery" mb={1}>
        {t("component:body.currentRecipientList")}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
        {selectedEmails?.map((email: string) => (
          <Chip
            key={email}
            variant="tag"
            label={email}
            size="micro"
            color="primary"
            onDelete={() => onDeleteEmail(email)}
          />
        ))}
      </Stack>
    </FormSection>
  );
};

export default ShareUserAccessBox;
